// Content for the once-per-day "Follow us on Facebook" promo modal.
//
// Tips-&-tricks posts pulled from facebook.com/SohozKaj on 2026-08-24.
//
// Thumbnails are hosted locally under public/images/fb/ (served from /images/fb/)
// so they never expire — unlike the signed, short-lived Facebook CDN URLs. To
// swap a post image, drop a new file in that folder and update the `thumbnail` path.
//
// Titles/captions follow the app language: each post carries `titleKey`/`captionKey`
// pointing at i18n keys under `fbPromo.posts.*` (see en.json / bn.json). To swap a
// post image, drop a new file in public/images/fb/ and update the `thumbnail` path.

/** The Facebook page users are asked to follow. Used by the Page Plugin embed and the fallback button. */
export const FB_PAGE_URL = 'https://www.facebook.com/SohozKaj/';

/** Up to 4 tips-&-tricks posts shown on the left column. */
export const FB_PROMO_POSTS = [
    {
        id: 'tip-2',
        thumbnail: '/images/fb/1.webp',
        titleKey: 'fbPromo.posts.retro80s.title',
        captionKey: 'fbPromo.posts.retro80s.caption',
        link: 'https://www.facebook.com/photo.php?fbid=122113878615208038',
    },
    {
        id: 'tip-3',
        thumbnail: '/images/fb/2.webp',
        titleKey: 'fbPromo.posts.vintageCinema.title',
        captionKey: 'fbPromo.posts.vintageCinema.caption',
        link: 'https://www.facebook.com/photo.php?fbid=122115235617208038',
    },
    {
        id: 'tip-4',
        thumbnail: '/images/fb/3.webp',
        titleKey: 'fbPromo.posts.romanticCouple.title',
        captionKey: 'fbPromo.posts.romanticCouple.caption',
        link: 'https://www.facebook.com/photo.php?fbid=122118402699208038',
    },
];
